/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { QueryPoint, QueryPoint$inboundSchema } from "./querypoint.js";

/**
 * A gap-filled timeseries for a single group value (one line on the chart).
 */
export type QuerySeries = {
  /**
   * The dimension value for this series. Empty string when no group_by was requested; 'Other' for the rolled-up remainder beyond top_n.
   */
  groupValue: string;
  /**
   * Time buckets in ascending order, gap-filled with zeros.
   */
  points: Array<QueryPoint>;
};

/** @internal */
export const QuerySeries$inboundSchema: z.ZodMiniType<QuerySeries, unknown> = z
  .pipe(
    z.object({
      group_value: z.string(),
      points: z.array(QueryPoint$inboundSchema),
    }),
    z.transform((v) => {
      return remap$(v, {
        "group_value": "groupValue",
      });
    }),
  );

export function querySeriesFromJSON(
  jsonString: string,
): SafeParseResult<QuerySeries, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => QuerySeries$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'QuerySeries' from JSON`,
  );
}
